WiseMetering.Views.Loading = WiseMetering.Views.Modal.Show.extend({
    template: 'templates/ui/modal/loading',
    className: 'modal_loading',
    width: 700,
    title: () => i18next.t('modal.title.loading'),
    buttons: [],
    draggable: false
});
